import { subHours } from 'date-fns'

export default {
    computed: {
        todayMinDate() {
            const today = new Date()

            today.setUTCHours(0, 0, 0, 0)

            return today.toISOString()
        },
        todayMaxDate() {
            const today = new Date()

            today.setUTCHours(23, 59, 59, 59)

            return today.toISOString()
        }
    },
    methods: {
        formatDate(date, withTime = true, placeholder = true, options = {}) {
            if (!date) {
                return placeholder ? '-' : ''
            }

            return withTime ? new Date(date).toLocaleString('pl-PL', options) : new Date(date).toLocaleDateString('pl-PL', options)
        },

        parseDuration(totalSeconds) {
            if (!totalSeconds || totalSeconds < 0) return '-'
            let hours = Math.floor(totalSeconds / 3600)

            totalSeconds %= 3600

            let minutes = Math.floor(totalSeconds / 60)
            let seconds = totalSeconds % 60

            hours = String(hours).padStart(2, '0')
            minutes = String(minutes).padStart(2, '0')
            seconds = String(seconds).padStart(2, '0')

            return `${hours}:${minutes}:${seconds}`
        },
        withdrawalDate(hours) {
            return subHours(new Date(), hours).toISOString()
        },
        getDayBackward(date) {
            return new Date(new Date(date).getTime() - 24 * 60 * 60 * 1000).toJSON().slice(0, 10)
        },
        getDayForward(date) {
            return new Date(new Date(date).getTime() + 24 * 60 * 60 * 1000).toJSON().slice(0, 10)
        },
        convertToMinutes(totalSeconds) {
            if (totalSeconds === null) return '-'

            return Math.floor(totalSeconds / 60)
        }
    }
}


